import { render, staticRenderFns } from "./DeleteBusiness.vue?vue&type=template&id=cb968058&scoped=true&lang=pug&"
import script from "./DeleteBusiness.vue?vue&type=script&lang=js&"
export * from "./DeleteBusiness.vue?vue&type=script&lang=js&"
import style0 from "./DeleteBusiness.vue?vue&type=style&index=0&id=cb968058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb968058",
  null
  
)

export default component.exports